import React from "react";
import { Layout } from "../../layouts/Layout";
import {
  CHECK_ICON,
  SD_WORKING_IMG01,
  SD_WORKING_IMG02,
  SERVICES_DETAILS03,
} from "../../lib/assets";
import { ServicesDetailsWrapper } from "../../components/ServicesDetails/ServicesDetailsWrapper";
import { BrandSeven } from "../../components/Brand/BrandSeven";

const ServicesDetailsPageThree = () => {
  return (
    <Layout footer = {2} breadcrumb={"Services"} title={"Documentation support"}>
      {/* services-details-area */}
      <ServicesDetailsWrapper>
        <div className="services-details-wrap">
       {/*   <div className="services-details-thumb">
            <img src={SERVICES_DETAILS03} alt="" style={{width:"854px", height:"450px"}} />
          </div>*/}
          <div className="services-details-content">
            <h2 className="title">Seamless Documentation Support: Streamline Your Business Processes            </h2>
            <p>
            At Trio Management Consultancy, we understand that accurate and well-structured documentation 
            is the backbone of any successful business. Whether you are implementing new management systems,
             adhering to regulatory standards, or improving operational efficiency, our Documentation 
             Support services are designed to simplify, standardize, and strengthen your processes.
            </p>
            <div className="sd-inner-wrap sd-inner-wrap-three">
              <div className="row align-items-center">
                <div className="col-43">
                  <div className="services-details-list-two">
                    <ul className="list-wrap">
                      <li>
                        <div className="icon">
                          <i className="flaticon-piggy-bank"></i>
                        </div>
                        <div className="content">
                          <h5 className="title">Achieve Regulatory Compliance</h5>
                          <p>
                          Effortlessly meet industry standards with well-maintained records.</p>
                        </div>
                      </li>
                      <li>
                        <div className="icon">
                          <i className="flaticon-calculator"></i>
                        </div>
                        <div className="content">
                          <h5 className="title">Improve Operational Efficiency</h5>
                          <p>
                          Streamline workflows with clear, standardized documentation.
                          </p>
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
                <div className="col-57">
                  <div className="content">
                    <h3 className="title-two">
                    Our Approach to Documentation Support
                    </h3>
                    <p>
                    At Trio Management Consultancy, we provide end-to-end documentation solutions customized to 
                    your business goals and industry standards. Our team of experts works closely with you to 
                    ensure precision, compliance, and clarity in every document.
                    </p>
                    <ul className="list-wrap">
                      <li>
                        <img src={CHECK_ICON} alt="" />
                        System & Process Documentation

                      </li>
                      <li>
                        <img src={CHECK_ICON} alt="" />
                        Regulatory & Compliance Support
                      </li>
                      <li>
                        <img src={CHECK_ICON} alt="" />
                        Regulatory & Compliance Support
                      </li>
                      <li>
                        <img src={CHECK_ICON} alt="" />
                        Document Standardization
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <div className="industrial-working-wrap">
              <h2 className="title-two">The Trio Advantage: Empower Your Business with Streamlined Documentation</h2>
              <p className="info-one">
              Partnering with Trio Management Consultancy means you gain a trusted ally in handling the 
              intricacies of documentation management, ensuring consistency, clarity, and professionalism 
              at every level. We understand that poorly managed or inconsistent documentation can lead to 
              operational inefficiencies, compliance risks, and communication breakdowns. That’s why our 
              expert team is dedicated to creating and maintaining documents that not only meet regulatory
               and industry standards but also enhance your organization’s performance.
              </p>
             {/* <div className="row">
                <div className="col-md-6">
                  <img src={SD_WORKING_IMG01} alt="" />
                </div>
                <div className="col-md-6">
                  <img src={SD_WORKING_IMG02} alt="" />
                </div>
              </div>*/}
              <p className="info-two">
              At Trio Management Consultancy, we believe that well-structured documentation is 
              more than just a necessity—it’s a strategic asset. Our approach ensures that your
              documents are comprehensive, accurate, and tailored to your unique business needs. 
              Whether it’s policy manuals, process workflows, or compliance records, we work 
              closely with you to develop materials that streamline your processes, improve 
              internal communication, and uphold your reputation in the industry.
              </p>

              <br/>
              <p>
                Simplify your business operations, achieve compliance with ease, and drive operational 
                efficiency through our expert Documentation Support services. With Trio Management 
                Consultancy, you can focus on your core business goals while we handle the complexities 
                of documentation, helping your organization stay organized, compliant, and ahead in today’s 
                competitive market.</p>
            </div>
          </div>
        </div>
      </ServicesDetailsWrapper>

      {/* brand-area */}
      <BrandSeven />
    </Layout>
  );
};

export default ServicesDetailsPageThree;
